<template>
<div class="group">
    <div class="nav">
        <div class="nav-title">
            <div class="item" :class="{active: curTitleIdx===k}" v-for='(i,k) in data' :key='k' @click="changeTitle(k, i.key)">{{i.name}}</div>
        </div>
    </div>
    <div class="container">
        <div class="nav-icon-text">
            <i class="active iconfont icon-index-copy"></i>
            <span class="active">{{getIndexData.fixedFieldMap['home']}}</span>
            <i class="iconfont icon-youjiantou"></i>
            <span>{{data[curTitleIdx].name}}</span>
        </div>
        <transition name="fade">  
            <router-view :data='renderLs' />
        </transition>  
    </div>
</div>    
</template>


<script>

import common from '../common'
import {mapGetters} from 'vuex'
export default {
    mixins: [common],
    data: () => ({
        type: "customer"
    }),
    computed: {
      ...mapGetters(['getIndexData']),
    }
}
</script>

<style lang="stylus" scoped>
@import "~styl/mixin.styl"

.fade-enter-active
    ts(.8s ease-in-out)
.fade-enter
    op(0)

theme = #f7aa05

.group
    ppr()
    mt(-200)
    bg(#fff)
    fs(0)
    .container
        container()
        .nav-icon-text
            .active
                c(theme)
            i  
                fs(14)
            span 
                pl(10)
                pr(10)
                fs(14)
                _hover()
    .nav 
        h(45)
        bg(rgba(255,255,255,.4))
        transform translateY(-100%)
        .nav-title
            .item   
                _hover()
                lh(45)
                fs(12)
                ib()
                c(#333)
                pl(20)
                pr(20)
                &:first-child 
                    ml(700)
                &.active 
                    c(#fff)
                    bg(#f7aa05)

</style>


// WEBPACK FOOTER //
// src/components/consumer/index.vue